export default {
  nav: {
      home: "首頁",
      products: "產品",
      resources: "內容資源",
      contact: "聯絡我們",
      about: "關於我們",
      download: "APP下載",
      app_download: "應用下載",
      leecho: "Le-Echo",
      levue: "樂見",
      lebond: "樂伴",
      lesound: "樂音",
      menu: "菜單"
  },
  resources_page: {
      title: "AIOT 內容資源",
      intro: "匯聚音樂、教育內容與原子能力，協助智能硬體團隊快速了解可接入的內容與服務。",
      all: "全部",
      count_unit: "項資源",
      view_detail: "查看詳情",
      back: "返回資源目錄",
      description: "資源介紹",
      scenarios: "應用場景",
      not_found: "未找到該資源",
      empty: "目前分類暫無資源"
  },
  swiper: {
      _1: ["智能表系列", "了解更多"],
      _2: ["牙箱表系列", "了解更多"],
      _3: ["滾輪表系列", "了解更多"]
  },
  about: {
      text_0: "關於我們",
      text_1: "中科華智（深圳）智能有限公司，是一家手表行業技術平台服務公司，公司前身是香港aupo從業30多年鍾表專業公司，2008年轉型爲手表行業提供技術服務，公司擁有①香港傳統表專業團隊②深圳硬件，軟件，app專業團隊③中山工廠基地生産團隊④爲傳統表品牌及行業品牌提供，智能表，（齒輪箱+模組）自定義指針功能機芯，技術支持。",
      text_2: "技術服務項目內容如下:",
      text_3: "一，智能手表藍牙方案服務商",
      text_4: "① 藍牙方案（擁有源代碼，支持功能定制服務）",
      text_5: "② 4G智能表方案",
      text_6: "③ 硬件，軟件，app技術服務",
      text_7: "④ 內容，界面，UI，訂制",
      text_8: "⑤ 智能表售後技術服務，app升級",
      text_9: "二，（齒輪箱+模組）自定義指針功能機芯",
      text_10: "① 自定義指針功能機芯，打破傳統表先有機芯，再設計手表模式，倒過來是先由手表品牌商來定義手表産品功能，設計表盤布局，我公司提供機芯結構+硬件堆疊+軟件程序技術服務",
      text_11: "② 手表品牌商可以任意排列機芯軸的位置，選擇機芯軸高度，選擇同心多軸或單軸齒輪箱，正轉，反轉，轉速，獨立馬達驅動",
      text_12: "③ 選擇機芯軸用途，計時針，計量針，動感動作，比如用于，模似車輪轉動，動物動作，飛鳥，蝴蝶動作，卡通人物動作，等等創意",
      text_13: "④ 齒輪箱可選擇，瑞士朗達，日本西鐵城，精工，大陸，豐儉由人",
      text_14: "⑤ 科技發展，手表智能化，功能化，需要跨界技術，分工合作，傳統機芯廠只提供專業齒輪箱，把手表産品産品定義交給手表品牌商，我公司提供機芯結構+硬件，軟件專業技術平台服務",
      text_15: "⑥ （齒輪箱+模組）自定義指針功能機芯，分爲2大類，A，指針智能表（帶app），B，指針功能表（不帶app）"
  },
  contact: {
      title: "聯絡我們",
      items: [{
          name: {
              name: "聯係人",
              value: "陳生"
          },
          changer: {
              name: "負責",
              value: "智能手錶"
          },
          tel: {
              name: "聯絡電話",
              value: "13794477351"
          },
          email: {
              name: "E-mail",
              value: "445995614@qq.com"
          }
      },{
        name: {
            name: "聯係人",
            value: "黃生"
        },
        changer: {
            name: "負責",
            value: "可編輯牙箱手錶"
        },
        tel: {
            name: "聯絡電話",
            value: "15626563096"
        },
        email: {
            name: "E-mail",
            value: "cliffwong65@yahoo.com"
        }
    }],
      address:[
          {
            addrName:'深圳研發基地',
            companyName:"深圳中科华智（智能）有限公司",
            addr:  "深圳寶安區松崗街道潭頭宇恒工業園三棟七樓"
          },
          {
            addrName:'香港公司',
            companyName: "恒锐投资有限公司",
            addr: "香港九龍大角咀榆樹街1號宏業工業大廈10樓1003室"
        },
        {
            addrName:'中山工厂',
            companyName:"中山中科美创智能科技有限公司",
            addr : "中山市南朗榄边村长岭路3号"
        }
      ]
  },
  products: {
      title: "產品",
      titleList: [{
          t_1: "產品及技術",
          t_2s: ["智能表系列", "牙箱表系列", "滾輪表系列"]
      }],
      productList: ["智能表系列", "牙箱表系列", "滾輪表系列"]
  },
  download: "掃描二維碼下載",
  download_page: {
    title: "APP下載",
    download_btn: "下載",
    qr_desc: "掃描上方二維碼，即可快速下載我們的應用程序。支持 iOS 和 Android 雙平台。",
    quick_links: "快速鏈接",
    contact: "聯繫我們"
  },
  footer_desc: "中科華智（深圳）智能有限公司，專注於智能手表技術平台服務。",
  footer_support: "服務支持",
  leecho: {
    title: "Le-Echo 智能眼镜应用",
    subtitle: "為智能眼镜打造的創新應用，集成智能交互與個性化服務於一體",
    description: "Le-Echo是一款專為智能眼镜打造的創新應用，集成智能交互與個性化服務於一體，為用戶帶來無縫銜接的數字與現實體驗。通過高效語音控制、實時視覺分析及情境感知技術，Le-Echo重新定義您感知世界的方式——無論是通訊、娛樂還是工作，一切盡在眼前。",
    feature1: {
      title: "高效語音控制",
      description: "通過先進的語音識別技術，實現對智能眼镜的精準控制，讓您的雙手得到解放"
    },
    feature2: {
      title: "實時視覺分析",
      description: "利用AI視覺技術，實時分析周圍環境，為您提供智能化的信息提示和建議"
    },
    feature3: {
      title: "情境感知技術",
      description: "智能感知當前場景和環境，自動調整應用功能，提供最適合的服務體驗"
    },
    download: {
      title: "立即下載",
      ios_label: "iOS 下載",
      ios_text: "App Store",
      android_label: "Android 下載",
      android_text: "Android"
    },
    footer: "無論是通訊、娛樂還是工作，Le-Echo讓一切盡在眼前",
    agreement: {
      prefix: "點擊下載即表示您同意",
      user: "《用戶協議》",
      and: "和",
      privacy: "《隱私政策》"
    }
  },
  footerNav: ["聯絡我們", "關於我們", "常見問題", "條款及細則"],
  footerFollow: "關注我們"
}
